export default [
  { name: 'Germany', displayName: 'Deutschland', disabled: false },
  { name: 'United Kingdom', displayName: 'Großbritannien', disabled: false },
  {
    name: 'United States',
    displayName: 'Vereinigte Staaten von Amerika',
    disabled: false,
  },
  { name: 'Australia', displayName: 'Australien', disabled: false },
  { name: 'Canada', displayName: 'Kanada', disabled: false },
  { name: 'France', displayName: 'Frankreich', disabled: false },
  { name: 'Spain', displayName: 'Spanien', disabled: false },
  { name: null, displayName: '---', disabled: true },
  { name: 'Afghanistan', displayName: 'Afghanistan', disabled: false },
  { name: 'Åland Islands', displayName: 'Åland Islands', disabled: false },
  { name: 'Albania', displayName: 'Albanien', disabled: false },
  { name: 'Algeria', displayName: 'Algerien', disabled: false },
  { name: 'American Samoa', displayName: 'American Samoa', disabled: false },
  { name: 'Andorra', displayName: 'Andorra', disabled: false },
  { name: 'Angola', displayName: 'Angola', disabled: false },
  { name: 'Anguilla', displayName: 'Anguilla', disabled: false },
  { name: 'Antarctica', displayName: 'Antarctica', disabled: false },
  {
    name: 'Antigua & Barbuda',
    displayName: 'Antigua & Barbuda',
    disabled: false,
  },
  { name: 'Argentina', displayName: 'Argentinien', disabled: false },
  { name: 'Armenia', displayName: 'Armenien', disabled: false },
  { name: 'Aruba', displayName: 'Aruba', disabled: false },
  {
    name: 'Ascension Island',
    displayName: 'Ascension Island',
    disabled: false,
  },
  { name: 'Austria', displayName: 'Österreich', disabled: false },
  { name: 'Azerbaijan', displayName: 'Aserbaidschan', disabled: false },
  { name: 'Bahamas', displayName: 'Bahamas', disabled: false },
  { name: 'Bahrain', displayName: 'Bahrain', disabled: false },
  { name: 'Bangladesh', displayName: 'Bangladesch', disabled: false },
  { name: 'Barbados', displayName: 'Barbados', disabled: false },
  { name: 'Belarus', displayName: 'Weißrussland', disabled: false },
  { name: 'Belgium', displayName: 'Belgien', disabled: false },
  { name: 'Belize', displayName: 'Belize', disabled: false },
  { name: 'Benin', displayName: 'Benin', disabled: false },
  { name: 'Bermuda', displayName: 'Bermuda', disabled: false },
  { name: 'Bhutan', displayName: 'Bhutan', disabled: false },
  { name: 'Bolivia', displayName: 'Bolivien', disabled: false },
  {
    name: 'Bosnia & Herzegovina',
    displayName: 'Bosnia & Herzegovina',
    disabled: false,
  },
  { name: 'Botswana', displayName: 'Botswana', disabled: false },
  { name: 'Brazil', displayName: 'Brasilien', disabled: false },
  {
    name: 'British Indian Ocean Territory',
    displayName: 'British Indian Ocean Territory',
    disabled: false,
  },
  {
    name: 'British Virgin Islands',
    displayName: 'British Virgin Islands',
    disabled: false,
  },
  { name: 'Brunei', displayName: 'Brunei', disabled: false },
  { name: 'Bulgaria', displayName: 'Bulgarien', disabled: false },
  { name: 'Burkina Faso', displayName: 'Burkina Faso', disabled: false },
  { name: 'Burundi', displayName: 'Burundi', disabled: false },
  { name: 'Cambodia', displayName: 'Kambodscha', disabled: false },
  { name: 'Cameroon', displayName: 'Kamerun', disabled: false },
  { name: 'Canary Islands', displayName: 'Canary Islands', disabled: false },
  { name: 'Cape Verde', displayName: 'Kap Verde', disabled: false },
  {
    name: 'Caribbean Netherlands',
    displayName: 'Caribbean Netherlands',
    disabled: false,
  },
  { name: 'Cayman Islands', displayName: 'Cayman Islands', disabled: false },
  {
    name: 'Central African Republic',
    displayName: 'Zentralafrikanische Republik',
    disabled: false,
  },
  { name: 'Ceuta & Melilla', displayName: 'Ceuta & Melilla', disabled: false },
  { name: 'Chad', displayName: 'Tschad', disabled: false },
  { name: 'Chile', displayName: 'Chile', disabled: false },
  { name: 'China', displayName: 'China', disabled: false },
  {
    name: 'Christmas Island',
    displayName: 'Christmas Island',
    disabled: false,
  },
  {
    name: 'Cocos (Keeling) Islands',
    displayName: 'Cocos (Keeling) Islands',
    disabled: false,
  },
  { name: 'Colombia', displayName: 'Kolumbien', disabled: false },
  { name: 'Comoros', displayName: 'Komoren', disabled: false },
  {
    name: 'Congo - Brazzaville',
    displayName: 'Congo - Brazzaville',
    disabled: false,
  },
  {
    name: 'Congo - Kinshasa',
    displayName: 'Congo - Kinshasa',
    disabled: false,
  },
  { name: 'Cook Islands', displayName: 'Cook Islands', disabled: false },
  { name: 'Costa Rica', displayName: 'Costa Rica', disabled: false },
  { name: 'Côte d’Ivoire', displayName: 'Côte d’Ivoire', disabled: false },
  { name: 'Croatia', displayName: 'Kroatien', disabled: false },
  { name: 'Cuba', displayName: 'Kuba', disabled: false },
  { name: 'Curaçao', displayName: 'Curaçao', disabled: false },
  { name: 'Cyprus', displayName: 'Zypern', disabled: false },
  {
    name: 'Czech Republic',
    displayName: 'Tschechische Republik',
    disabled: false,
  },
  { name: 'Denmark', displayName: 'Dänemark', disabled: false },
  { name: 'Diego Garcia', displayName: 'Diego Garcia', disabled: false },
  { name: 'Djibouti', displayName: 'Dschibuti', disabled: false },
  { name: 'Dominica', displayName: 'Dominica', disabled: false },
  {
    name: 'Dominican Republic',
    displayName: 'Dominikanische Republik',
    disabled: false,
  },
  { name: 'Ecuador', displayName: 'Ecuador', disabled: false },
  { name: 'Egypt', displayName: 'Ägypten', disabled: false },
  { name: 'El Salvador', displayName: 'El Salvador', disabled: false },
  {
    name: 'Equatorial Guinea',
    displayName: 'Äquatorialguinea',
    disabled: false,
  },
  { name: 'Eritrea', displayName: 'Eritrea', disabled: false },
  { name: 'Estonia', displayName: 'Estland', disabled: false },
  { name: 'Ethiopia', displayName: 'Äthiopien', disabled: false },
  {
    name: 'Falkland Islands',
    displayName: 'Falkland Islands',
    disabled: false,
  },
  { name: 'Faroe Islands', displayName: 'Faroe Islands', disabled: false },
  { name: 'Fiji', displayName: 'Fidschi', disabled: false },
  { name: 'Finland', displayName: 'Finnland', disabled: false },
  { name: 'French Guiana', displayName: 'French Guiana', disabled: false },
  {
    name: 'French Polynesia',
    displayName: 'French Polynesia',
    disabled: false,
  },
  {
    name: 'French Southern Territories',
    displayName: 'French Southern Territories',
    disabled: false,
  },
  { name: 'Gabon', displayName: 'Gabun', disabled: false },
  { name: 'Gambia', displayName: 'Gambia', disabled: false },
  { name: 'Georgia', displayName: 'Georgia', disabled: false },
  { name: 'Ghana', displayName: 'Ghana', disabled: false },
  { name: 'Gibraltar', displayName: 'Gibraltar', disabled: false },
  { name: 'Greece', displayName: 'Griechenland', disabled: false },
  { name: 'Greenland', displayName: 'Greenland', disabled: false },
  { name: 'Grenada', displayName: 'Grenada', disabled: false },
  { name: 'Guadeloupe', displayName: 'Guadeloupe', disabled: false },
  { name: 'Guam', displayName: 'Guam', disabled: false },
  { name: 'Guatemala', displayName: 'Guatemala', disabled: false },
  { name: 'Guernsey', displayName: 'Guernsey', disabled: false },
  { name: 'Guinea', displayName: 'Guinea', disabled: false },
  { name: 'Guinea-Bissau', displayName: 'Guinea-Bissau', disabled: false },
  { name: 'Guyana', displayName: 'Guyana', disabled: false },
  { name: 'Haiti', displayName: 'Haiti', disabled: false },
  { name: 'Honduras', displayName: 'Honduras', disabled: false },
  { name: 'Hong Kong', displayName: 'Hong Kong', disabled: false },
  { name: 'Hungary', displayName: 'Ungarn', disabled: false },
  { name: 'Iceland', displayName: 'Island', disabled: false },
  { name: 'India', displayName: 'Indien', disabled: false },
  { name: 'Indonesia', displayName: 'Indonesien', disabled: false },
  { name: 'Iran', displayName: 'Iran', disabled: false },
  { name: 'Iraq', displayName: 'Irak', disabled: false },
  { name: 'Ireland', displayName: 'Irland', disabled: false },
  { name: 'Isle of Man', displayName: 'Isle of Man', disabled: false },
  { name: 'Israel', displayName: 'Israel', disabled: false },
  { name: 'Italy', displayName: 'Italien', disabled: false },
  { name: 'Jamaica', displayName: 'Jamaika', disabled: false },
  { name: 'Japan', displayName: 'Japan', disabled: false },
  { name: 'Jersey', displayName: 'Jersey', disabled: false },
  { name: 'Jordan', displayName: 'Jordanien', disabled: false },
  { name: 'Kazakhstan', displayName: 'Kasachstan', disabled: false },
  { name: 'Kenya', displayName: 'Kenia', disabled: false },
  { name: 'Kiribati', displayName: 'Kiribati', disabled: false },
  { name: 'Kosovo', displayName: 'Kosovo', disabled: false },
  { name: 'Kuwait', displayName: 'Kuwait', disabled: false },
  { name: 'Kyrgyzstan', displayName: 'Kirgistan', disabled: false },
  { name: 'Laos', displayName: 'Laos', disabled: false },
  { name: 'Latvia', displayName: 'Lettland', disabled: false },
  { name: 'Lebanon', displayName: 'Libanon', disabled: false },
  { name: 'Lesotho', displayName: 'Lesotho', disabled: false },
  { name: 'Liberia', displayName: 'Liberia', disabled: false },
  { name: 'Libya', displayName: 'Libyen', disabled: false },
  { name: 'Liechtenstein', displayName: 'Liechtenstein', disabled: false },
  { name: 'Lithuania', displayName: 'Litauen', disabled: false },
  { name: 'Luxembourg', displayName: 'Luxemburg', disabled: false },
  { name: 'Macau SAR China', displayName: 'Macau SAR China', disabled: false },
  { name: 'Macedonia', displayName: 'Mazedonien', disabled: false },
  { name: 'Madagascar', displayName: 'Madagaskar', disabled: false },
  { name: 'Malawi', displayName: 'Malawi', disabled: false },
  { name: 'Malaysia', displayName: 'Malaysia', disabled: false },
  { name: 'Maldives', displayName: 'Malediven', disabled: false },
  { name: 'Mali', displayName: 'Mali', disabled: false },
  { name: 'Malta', displayName: 'Malta', disabled: false },
  {
    name: 'Marshall Islands',
    displayName: 'Marshallinseln',
    disabled: false,
  },
  { name: 'Martinique', displayName: 'Martinique', disabled: false },
  { name: 'Mauritania', displayName: 'Mauretanien', disabled: false },
  { name: 'Mauritius', displayName: 'Mauritius', disabled: false },
  { name: 'Mayotte', displayName: 'Mayotte', disabled: false },
  { name: 'Mexico', displayName: 'Mexiko', disabled: false },
  { name: 'Micronesia', displayName: 'Mikronesien', disabled: false },
  { name: 'Moldova', displayName: 'Moldawien', disabled: false },
  { name: 'Monaco', displayName: 'Monaco', disabled: false },
  { name: 'Mongolia', displayName: 'Mongolei', disabled: false },
  { name: 'Montenegro', displayName: 'Montenegro', disabled: false },
  { name: 'Montserrat', displayName: 'Montserrat', disabled: false },
  { name: 'Morocco', displayName: 'Marokko', disabled: false },
  { name: 'Mozambique', displayName: 'Mosambik', disabled: false },
  { name: 'Myanmar (Burma)', displayName: 'Myanmar (Burma)', disabled: false },
  { name: 'Namibia', displayName: 'Namibia', disabled: false },
  { name: 'Nauru', displayName: 'Nauru', disabled: false },
  { name: 'Nepal', displayName: 'Nepal', disabled: false },
  { name: 'Netherlands', displayName: 'Niederlande', disabled: false },
  { name: 'New Caledonia', displayName: 'New Caledonia', disabled: false },
  { name: 'New Zealand', displayName: 'Neuseeland', disabled: false },
  { name: 'Nicaragua', displayName: 'Nicaragua', disabled: false },
  { name: 'Niger', displayName: 'Niger', disabled: false },
  { name: 'Nigeria', displayName: 'Nigeria', disabled: false },
  { name: 'Niue', displayName: 'Niue', disabled: false },
  { name: 'Norfolk Island', displayName: 'Norfolk Island', disabled: false },
  { name: 'North Korea', displayName: 'Nordkorea', disabled: false },
  {
    name: 'Northern Mariana Islands',
    displayName: 'Northern Mariana Islands',
    disabled: false,
  },
  { name: 'Norway', displayName: 'Norwegen', disabled: false },
  { name: 'Oman', displayName: 'Oman', disabled: false },
  { name: 'Pakistan', displayName: 'Pakistan', disabled: false },
  { name: 'Palau', displayName: 'Palau', disabled: false },
  {
    name: 'Palestinian Territories',
    displayName: 'Palästinensische Autonomiegebiete',
    disabled: false,
  },
  { name: 'Panama', displayName: 'Panama', disabled: false },
  {
    name: 'Papua New Guinea',
    displayName: 'Papua-Neuguinea',
    disabled: false,
  },
  { name: 'Paraguay', displayName: 'Paraguay', disabled: false },
  { name: 'Peru', displayName: 'Peru', disabled: false },
  { name: 'Philippines', displayName: 'Philippinen', disabled: false },
  {
    name: 'Pitcairn Islands',
    displayName: 'Pitcairn Islands',
    disabled: false,
  },
  { name: 'Poland', displayName: 'Polen', disabled: false },
  { name: 'Portugal', displayName: 'Portugal', disabled: false },
  { name: 'Puerto Rico', displayName: 'Puerto Rico', disabled: false },
  { name: 'Qatar', displayName: 'Katar', disabled: false },
  { name: 'Réunion', displayName: 'Réunion', disabled: false },
  { name: 'Romania', displayName: 'Rumänien', disabled: false },
  { name: 'Russia', displayName: 'Russland', disabled: false },
  { name: 'Rwanda', displayName: 'Ruanda', disabled: false },
  { name: 'Samoa', displayName: 'Samoa', disabled: false },
  { name: 'San Marino', displayName: 'San Marino', disabled: false },
  {
    name: 'São Tomé & Príncipe',
    displayName: 'São Tomé & Príncipe',
    disabled: false,
  },
  { name: 'Saudi Arabia', displayName: 'Saudi-Arabien', disabled: false },
  { name: 'Senegal', displayName: 'Senegal', disabled: false },
  { name: 'Serbia', displayName: 'Serbien', disabled: false },
  { name: 'Seychelles', displayName: 'Seychellen', disabled: false },
  { name: 'Sierra Leone', displayName: 'Sierra Leone', disabled: false },
  { name: 'Singapore', displayName: 'Singapur', disabled: false },
  { name: 'Sint Maarten', displayName: 'Sint Maarten', disabled: false },
  { name: 'Slovakia', displayName: 'Slowakei', disabled: false },
  { name: 'Slovenia', displayName: 'Slowenien', disabled: false },
  { name: 'Solomon Islands', displayName: 'Salomonen', disabled: false },
  { name: 'Somalia', displayName: 'Somalia', disabled: false },
  { name: 'South Africa', displayName: 'Südafrika', disabled: false },
  {
    name: 'South Georgia & South Sandwich Islands',
    displayName: 'South Georgia & South Sandwich Islands',
    disabled: false,
  },
  { name: 'South Korea', displayName: 'Südkorea', disabled: false },
  { name: 'South Sudan', displayName: 'South Sudan', disabled: false },
  { name: 'Sri Lanka', displayName: 'Sri Lanka', disabled: false },
  { name: 'St. Barthélemy', displayName: 'St. Barthélemy', disabled: false },
  { name: 'St. Helena', displayName: 'St. Helena', disabled: false },
  {
    name: 'St. Kitts & Nevis',
    displayName: 'St. Kitts & Nevis',
    disabled: false,
  },
  { name: 'St. Lucia', displayName: 'St. Lucia', disabled: false },
  { name: 'St. Martin', displayName: 'St. Martin', disabled: false },
  {
    name: 'St. Pierre & Miquelon',
    displayName: 'St. Pierre & Miquelon',
    disabled: false,
  },
  {
    name: 'St. Vincent & Grenadines',
    displayName: 'St. Vincent & Grenadines',
    disabled: false,
  },
  { name: 'Sudan', displayName: 'Sudan', disabled: false },
  { name: 'Suriname', displayName: 'Surinam', disabled: false },
  {
    name: 'Svalbard & Jan Mayen',
    displayName: 'Svalbard & Jan Mayen',
    disabled: false,
  },
  { name: 'Swaziland', displayName: 'Swasiland', disabled: false },
  { name: 'Sweden', displayName: 'Schweden', disabled: false },
  { name: 'Switzerland', displayName: 'Schweiz', disabled: false },
  { name: 'Syria', displayName: 'Syrien', disabled: false },
  { name: 'Taiwan', displayName: 'Taiwan', disabled: false },
  { name: 'Tajikistan', displayName: 'Tadschikistan', disabled: false },
  { name: 'Tanzania', displayName: 'Tanzania', disabled: false },
  { name: 'Thailand', displayName: 'Thailand', disabled: false },
  { name: 'Timor-Leste', displayName: 'Osttimor', disabled: false },
  { name: 'Togo', displayName: 'Togo', disabled: false },
  { name: 'Tokelau', displayName: 'Tokelau', disabled: false },
  { name: 'Tonga', displayName: 'Tonga', disabled: false },
  {
    name: 'Trinidad & Tobago',
    displayName: 'Trinidad & Tobago',
    disabled: false,
  },
  {
    name: 'Tristan da Cunha',
    displayName: 'Tristan da Cunha',
    disabled: false,
  },
  { name: 'Tunisia', displayName: 'Tunesien', disabled: false },
  { name: 'Turkey', displayName: 'Türkei', disabled: false },
  { name: 'Turkmenistan', displayName: 'Turkmenistan', disabled: false },
  {
    name: 'Turks & Caicos Islands',
    displayName: 'Turks & Caicos Islands',
    disabled: false,
  },
  { name: 'Tuvalu', displayName: 'Tuvalu', disabled: false },
  {
    name: 'U.S. Outlying Islands',
    displayName: 'U.S. Outlying Islands',
    disabled: false,
  },
  {
    name: 'U.S. Virgin Islands',
    displayName: 'U.S. Virgin Islands',
    disabled: false,
  },
  { name: 'Uganda', displayName: 'Uganda', disabled: false },
  { name: 'Ukraine', displayName: 'Ukraine', disabled: false },
  {
    name: 'United Arab Emirates',
    displayName: 'Vereinigte Arabische Emirate',
    disabled: false,
  },
  { name: 'Uruguay', displayName: 'Uruguay', disabled: false },
  { name: 'Uzbekistan', displayName: 'Usbekistan', disabled: false },
  { name: 'Vanuatu', displayName: 'Vanuatu', disabled: false },
  { name: 'Vatican City', displayName: 'Vatican City', disabled: false },
  { name: 'Venezuela', displayName: 'Venezuela', disabled: false },
  { name: 'Vietnam', displayName: 'Vietnam', disabled: false },
  { name: 'Wallis & Futuna', displayName: 'Wallis & Futuna', disabled: false },
  { name: 'Western Sahara', displayName: 'Western Sahara', disabled: false },
  { name: 'Yemen', displayName: 'Jemen', disabled: false },
  { name: 'Zambia', displayName: 'Sambia', disabled: false },
  { name: 'Zimbabwe', displayName: 'Simbabwe', disabled: false },
];
